import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

import { SearchedSilobagData, SearchSilobagPayload } from './silobag-search.types';

export async function searchSilobagService({ query: search }: SearchSilobagPayload) {
  const { organizationId } = useGlobalStore.getState();
  const query = transformIntoQueryParamString(search, { organization_id: organizationId });

  const { response, data } = await BACKEND.get<SearchedSilobagData>(ENDPOINT.SILOBAGS_SEARCH, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
